import React from "react";
import { Modal } from "antd";
import CrmCallHistoryForm from "./CrmCallHistoryForm";
import { useGeneralStore } from "../../../../store/slices/createGeneralSlice";

export default function CrmCallHistoryModal({ usrUserID, requestId, renewalCall, detailsCall, historyCall, newRenewalCall }) {

  const general = useGeneralStore();
  const visible = general.view.crmCallHistoryModal;

  return (
    <div>
      <Modal
        width={800}
        title={"تماس جدید"}
        className="custom-table crm-request-report"
        visible={visible}
        footer={false}
        onCancel={() => general.ToggleCrmCallHistoryModal(true)}
      >
        <CrmCallHistoryForm
          onSubmit={() => {
            general.ToggleCrmCallHistoryModal(true);
          }}
          usrUserID={usrUserID}
          requestId={requestId}
          renewalCall={renewalCall}
          newRenewalCall={newRenewalCall}
          detailsCall={detailsCall}
          historyCall={historyCall}
        />
      </Modal>
    </div>
  );
}
// این مودال در ستون تماس در صفحه گزارش تمدید
// و
// دکمه افزودن تماس جدید در تب گزارش تماس  در مودال جزییات کاربر نمایش داده می شود 
